import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


export const DriverRegistrationCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    //Driver Registration create
    const [names, setNames] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [IDCard, setIDCards] = useState("");
    const [license, setLicense] = useState("");
    const [licenseValidity, setlicenseValidity] = useState("");
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!names || !contactNumber) {
            setErrorMessages("All fields are required!");
            setIsLoading(false);
            return;
        }

        try {
            const DriverCreateData = {

                CompanyID: companyId,
                Name: names,
                ContactNumber: contactNumber,
                IDCard: IDCard,
                LicenseNo: license,
                LicenseDueDate: licenseValidity,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('DriverApi', DriverCreateData, token)
                .then((response) => {
                    console.log('DriverRegistration Created success:', response);
                    setNames("");
                    setContactNumber("");
                    setIDCards("");
                    setLicense("");
                    setlicenseValidity("");
                    setSuccessMessages("DriverRegistration Created successful!");
                    setErrorMessages(""); // Clear error message on success
                    history.push('/DriverRegistrationIndex');

                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000); // 3 seconds
                })
                .catch((error) => {
                    console.error('DriverRegistration Create error:', error);
                    setIsLoading(false);
                });


        }
        catch (error) {
            console.error('DriverRegistration Create error:', error);
        }
    };

    /* End API */

    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <div className="w-full mb-4 flex">

                    <form onSubmit={submitData}>

                        <div className='w-full mb-2 flex items-center'>
                            <h4 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Create</h4>


                            <Tooltip title="Exit">
                                <Link to="/DriverRegistrationIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                    <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                        Back-To-List <ExitToAppIcon />
                                    </Button>
                                </Link>
                            </Tooltip>


                            <Tooltip title="SAVE">

                                <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                                </Button>

                            </Tooltip>


                        </div>
                        {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                        {successMessages && <p className="text-green-500">{successMessages}</p>}
                        <br></br>
                        <div className="w-full mb-4 flex">

                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={names}
                                    onChange={(e) => setNames(e.target.value)}
                                    type="text"
                                    placeholder="Enter Name"
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber1">
                                    ContactNo
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={contactNumber}
                                    onChange={(e) => {
                                        const input = e.target.value.replace(/\D/g, '');
                                        if (input.length <= 15) {
                                            setContactNumber(input);
                                        }
                                    }}
                                    type="text"
                                    placeholder="Contact Number "
                                />
                            </div>


                            <div className="w-1/4 mr-2">
                                <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="email">
                                    IDCard
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={IDCard} onChange={(e) => setIDCards(e.target.value)} type="text" placeholder="IDCard" />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="gstNumber">
                                    License No
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={license} onChange={(e) => setLicense(e.target.value)} maxLength={15} type="text" placeholder="License Number" />
                            </div>

                            <div className="mr-2">
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                    License Date
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="date" value={licenseValidity} onChange={(e) => setlicenseValidity(e.target.value)}

                                />
                            </div>


                        </div>

                    </form>
                </div>
            </div>

        </Fragment>
    );
}


